import React from 'react';
import { t } from 'ttag';

import setLanguage from '../translations/general_trans';

export default class ConfirmStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gTrans: setLanguage('general', window.config.language_code),
      text: t`You’re at the goal line!`,
      text2: t`If you are new at Unisport you need to confirm that you’re not a robot by clicking the confirmation mail we just sent you.`,
      text3: t`Not receiving emails from us? Please check your spam folder.`
    };
  }

  // UNSAFE_componentWillMount() {
  //   // handling austrian translations
  //   if (window.config.language_code === 'de-AT') {
  //     this.setState({
  //       gTrans: generalTrans.at,
  //     });
  //   }
  // }

  render() {
    return (
      <section className="confirm-section">
        <h4>{this.state.gTrans.headlineStep3}</h4>
        <div className="confirmationTextHolder">
          <p className="confirmation1">{this.state.text}</p>
          <p className="confirmation1">{this.state.text2}</p>
          <p className="confirmation1">{this.state.text3}</p>
        </div>
      </section>
    );
  }
}
